import { render, staticRenderFns } from "./IntegrationsModal.vue?vue&type=template&id=c8baad56&scoped=true&"
import script from "./IntegrationsModal.vue?vue&type=script&lang=js&"
export * from "./IntegrationsModal.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationsModal.vue?vue&type=style&index=0&id=c8baad56&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8baad56",
  null
  
)

export default component.exports